import styled, { css } from 'styled-components';

export const BasePicture = styled.picture`
  ${() => css`
    display: flex;
  `}
`;

export const PictureImage = styled.img`
  ${({ variant, fullWidth }) => {
    let borderRadius;
    if (variant === 'secondary') {
      borderRadius = 100;
    } else {
      borderRadius = 0;
    }
    let width;
    if (fullWidth || fullWidth === 'true') {
      width = '100%';
    } else {
      width = 'auto';
    }

    return css`
      border-radius: ${borderRadius}%;
      width: ${width}
  `;
  }
}
`;
